import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { ListDisplayType } from '../../../containers/DriveItemList/constants';
import { SelectionType } from '../../../containers/Selection/actions';
import { toggleNotesEditor } from '../../../containers/NotesPage/actions';
import { LoadingStatus } from '../../../containers/NotesPage/reducer';
import { ThumbnailDescriptor } from '../../../utils/driveItem';
import ListItem from '../../ListItem';
import IndexedDBManager from '../../../utils/indexedDB/manager';
import usePreviousValue from '../../../utils/customHooks/usePreviousValue';
import { Api } from '../../../typings/api';

interface NoteListItemProps {
	id: number;
	isOpened: boolean;
	loadingStatus: LoadingStatus;
	displayType: ListDisplayType;
	type: Api.AdditionalItemType.Note;
	dispatch: Dispatch<StoreState>;
}

const NoteListItem = ({
	id,
	isOpened,
	loadingStatus,
	displayType,
	dispatch,
}: NoteListItemProps) => {
	const [imageSrc, setImageSrc] = React.useState('');
	const [label, setLabel] = React.useState('');
	const prevIsOpened = usePreviousValue(isOpened);
	const prevLoadingStatus = usePreviousValue(loadingStatus);

	React.useEffect(() => {
		IndexedDBManager.getNote(id).then(note => {
			if (note) {
				setImageSrc(note.drawing);
				setLabel(note.title);
			}
		});
	}, [id]);

	// is needed to update note title/image
	React.useEffect(() => {
		const isLocalNoteChanged = prevIsOpened && !isOpened;
		const isSharedNoteChanged = prevLoadingStatus === LoadingStatus.SAVING && loadingStatus === LoadingStatus.LOADED;

		if (isLocalNoteChanged || isSharedNoteChanged) {
			setTimeout(() => {
				IndexedDBManager.getNote(id).then(note => {
					if (note) {
						setImageSrc(note.drawing);
						setLabel(note.title);
					}
				});
			}, 0);
		}
	}, [id, isOpened, loadingStatus]);

	const handleClick = () => {
		dispatch(toggleNotesEditor(id));
	};

	const thumbnailDescriptor: ThumbnailDescriptor = {
		isImage: !!imageSrc,
		src: imageSrc || 'iconset_uprez_notes',
	};

	return (
		<ListItem
			itemId={id}
			onClick={handleClick}
			showUnreadBadge={false}
			displayType={displayType}
			itemType={Api.AdditionalItemType.Note}
			hasActionButton={false}
			label={label}
			isSelectedForContextualMenu={false}
			isDownloading={false}
			isDownloaded={false}
			isDownloadInProgress={false}
			isUpdating={false}
			loaderStep={undefined}
			thumbnailDescriptor={thumbnailDescriptor}
			isUnread={false}
			isEditMode={false}
			selectionType={SelectionType.NOTES}
		/>
	);
};

export default NoteListItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesPage/NoteListItem/index.tsx